import React from 'react'
import Modal from 'react-bootstrap/Modal'
import {Ite} from './item.styled'



export default function Item() {
  const item = JSON.parse(localStorage.getItem('item'))
  return (
    <div>
      <Modal
      show
      centered
      onHide={()=>window.history.back()}>
        <Modal.Header closeButton> <h3 style={{margin: '0px'}}>{item.category}</h3></Modal.Header>
        <Modal.Body>
          <Ite>
          <div className="itm-con">
            <main>
            <img src={item.image_url} alt={item.name} />
            <h4>{item.name}</h4>
            <p>{item.description}</p>
            <h5>R {item.price}</h5>
            </main>
          </div>
          </Ite>
        </Modal.Body>
      </Modal>
    </div>
  )
}
